import { render } from "./avatars.vue?vue&type=template&id=31ec7265"
import script from "./avatars.vue?vue&type=script&lang=js"
export * from "./avatars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__